<template>
  <!-- 左侧面板 - 三块区域 -->
  <div class="left-panel">
    <!-- 第一块：Tab切换表格 -->
    <div class="left-section left-section-1 border-box">
      <leftTabsTableView />
    </div>

    <!-- 第二块：年龄分布和性别比例 -->
    <div class="left-section left-section-2 border-box">
      <AgeGenderChart />
    </div>

    <!-- 第三块：月份疾病趋势 -->
    <div class="left-section left-section-3 border-box">
      <DiseaseTrendChart />
    </div>
  </div>
</template>
<script>
import leftTabsTableView from "../left2/leftTabsTableView.vue";
import AgeGenderChart from "../left2/AgeGenderChart.vue";
import DiseaseTrendChart from "../left2/DiseaseTrendChart.vue";

export default {
  components: {
    leftTabsTableView,
    AgeGenderChart,
    DiseaseTrendChart,
  }
}
</script>
<style scoped lang="scss">
.left-panel {
  width: 20%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .border-box {
        background: url("../../../assets/map/border-bg2.png") center center no-repeat;
        background-size: 100% 100%;
      }
  .left-section {
    // border: 2px solid;
    // border-radius: 4px;
    padding: 10px;
    overflow: hidden;

    &.left-section-1 {
      // flex: 1;
      // height: 400px;
      height: 300px;
      // background-image: url(../../assets//left-panel-bg.png);
      // background-size: 100% 100%;
      // background-repeat: no-repeat;
      // border-color: #ff6b6b; // 红色 - Tab表格区域
      // background-color: rgba(255, 107, 107, 0.1);
    }

    &.left-section-2 {
      flex: 1;
      min-height: 250px;
      // border-color: #4ecdc4; // 青色 - 年龄性别区域
      // background-color: rgba(78, 205, 196, 0.1);
    }

    &.left-section-3 {
      flex: 1;
      min-height: 200px;
      // border-color: #95e1d3; // 浅青色 - 疾病趋势区域
      // background-color: rgba(149, 225, 211, 0.1);
    }
  }
}
</style>